<template>
  <div class="popup-response error-popup popup-all" style="display: block">
    <div class="popup-container">
      <div class="popup-vue has-header">
        <div class="popup-header">
          <img class="popup-logo" src="/img/credit-landing-vue/popup-logo.svg">
          <div class="popup-tel" v-html="__t('Телефон для нам прикро')"></div>
        </div>
        <div class="popup-content-on-mob">

          <div class="popup-img">
            <img src="/img/credit-landing-vue/response-error.svg" alt="error">
          </div>


          <div class="popup-title" v-if="true">{{__t('Нам прикро')}}</div>
          <div class="popup-description">
            <p v-html="__t(errorMessage)"></p>
          </div>


          <div class="button-wrapper page-bottom ">
            <a id="closePopupFocusId" tabindex="0" class="single-button btn violet-btn" @click="popupClose()" @keydown.enter.prevent="popupClose()">{{__t('Закрити')}}</a>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

    export default {
        name: 'popup-error',
        props: {
          errorMessage: {
            type: String,
            default: ''
          }
        },
        data() {
            return {}
        },
        methods: {
            __t(phrase) {
                return window.__t(phrase);
            },
            popupClose: function () {
                this.$emit('popupErrorHide')
            }
        }
    }

</script>